import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-survey-post-stay",
  "use": "icon-survey-post-stay-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-survey-post-stay\">\n<path d=\"M16 1H8V5H16V1Z\" fill=\"currentColor\" />\n<path d=\"M6 3H3V23H12.75V11H21V3H18V7H6V3Z\" fill=\"currentColor\" />\n<path d=\"M14.75 12.9961H23.25V23.2906L19.0029 20.6742L14.75 23.2886V12.9961Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol